import React from 'react';
import PropTypes from 'prop-types';

import GlobeLogo from './svg/GlobeLogo';

import '../css/footer.css';

const Footer = props => (
  <footer className="bg__footer">
    <div className="bg__footer-content">
      <div className="credits__logo">
        <GlobeLogo />
      </div>  
      {Object.keys(props.credits).map(key => 
        <div className="credits__block" index={key} key={key}>
          <p className="credits__role benton-cond-regular"><strong>{props.credits[key].role}: </strong>{props.credits[key].value}</p>
        </div>
      )}
      <p className="credits__date benton-cond-regular">© {new Date().getFullYear()} Boston Globe Media Partners, LLC</p>
    </div>
  </footer>
)

Footer.propTypes = {
  credits: PropTypes.shape({
    role: PropTypes.string,
    value: PropTypes.string,
  }),
}

export default Footer;